export enum EAuthSettingsSection {
  PASSWORD = 'password',
  TOTP = 'totp',
  WEB_AUTHN = 'webauthn',
  LOOKUP_SECRET = 'lookup_secret',
  OIDC = 'oidc',
}
